// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"484":"62645ba73efa5912","888":"a10c466f43df79af"}[chunkId] + ".css";
};